import { Loading } from '../Loading';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  isLoading?: boolean;
  text: string;
};

export function Button({ isLoading, text, ...rest }: Props) {
  return (
    <button className="button" disabled={isLoading} {...rest}>
      {isLoading ? <Loading /> : text}
    </button>
  );
}
